// valid token = 8db5088d306a4731b2aee02cf9088652
const useOnlineShopping = () => {
  const { fa2en } = useInputHelpers();
  const config = useRuntimeConfig();
  const loading = ref(false);
  const register = async (payload) => {
    try {
      loading.value = true;
      payload.body.CompanyAgentFullName = payload.body.agentFirstname
        ? payload.body.agentFirstname + " " + payload.body.agentLastname
        : "";
      payload.body.CompanyAgentNatCode =
        fa2en(payload.body.CompanyAgentNatCode) || "";
      payload.body.CompanyAgentMobileNo =
        fa2en(payload.body.CompanyAgentMobileNo) || "";
      payload.body.CompanyName = payload.body.CompanyName || "";
      payload.body.CompanyShenaseMeli =
        fa2en(payload.body.CompanyShenaseMeli) || "";
      payload.body.CompanyAddress = payload.body.CompanyAddress || "";
      payload.body.CompanyPostalCode =
        fa2en(payload.body.CompanyPostalCode) || "";
      payload.body.type = payload.body.type || "";
      payload.body.ActivityTitle = payload.body.ActivityTitle || "";
      ////////////////////
      payload.body.FName = payload.body.FName || "";
      payload.body.LName = payload.body.LName || "";
      payload.body.NatCode = fa2en(payload.body.NatCode) || "";
      payload.body.MobileNo = fa2en(payload.body.MobileNo) || "";
      payload.body.Email = payload.body.Email || "";
      payload.body.City = payload.body.City || "";
      payload.body.CloudNo = payload.body.CloudNo || "";

      // payload.body.oparams = localStorage.getItem("params_value") || "{}";
      const options = {
        method: "POST",
        body: JSON.stringify(payload.body),
        initialCache: false,
      };
      const { data, pending, error, refresh } = await useFetch(
        config.public.BASE_URL + `/public/registerreq`,
        options
      );
      if (error.value) {
        console.log(error);
      } else {
        if (payload.body.FName || payload.body.LName) {
          useState("userName", payload.body.FName + " " + payload.body.LName);
        } else {
          useState(
            "userName",
            payload.body.agentFirstname + " " + payload.body.agentLastname
          );
        }
        useState("user_type", () => payload.body.type);
      }
      loading.value = false;
      return {
        data,
        pending,
        error,
        refresh,
      };
    } catch (err) {
      loading.value = false;
      console.error(err);
    }
  };

  const verifyOTP = async (payload) => {
    try {
      loading.value = true;

      payload.body.token = useState("token").value || "";
      const options = {
        method: "POST",
        body: JSON.stringify(payload.body),
      };
      const { data, pending, error, refresh } = await useFetch(
        config.public.BASE_URL + `/public/verifyCode`,
        options
      );
      if (error.value) {
        console.log(error);
      }
      loading.value = false;
      return {
        data,
        pending,
        error,
        refresh,
      };
    } catch (err) {
      loading.value = false;
      console.error(err);
    }
  };

  const resendOTP = async (payload) => {
    try {
      loading.value = true;
      payload.body.token = useState("token").value || "";
      const options = {
        method: "POST",
        body: JSON.stringify(payload.body),
      };
      const { data, pending, error, refresh } = await useFetch(
        config.public.BASE_URL + `/public/retryVerification`,
        options
      );
      if (error.value) {
        console.log(error);
      }
      loading.value = false;
      return {
        data,
        pending,
        error,
        refresh,
      };
    } catch (err) {
      loading.value = false;
      console.error(err);
    }
  };

  const getBundles = async (payload) => {
    try {
      loading.value = true;
      const options = {
        method: "POST",
        body: JSON.stringify(payload.body),
      };
      const { data, pending, error, refresh } = await useFetch(
        config.public.BASE_URL + `/public/SelectBundles`,
        options
      );
      if (error.value) {
        console.log(error);
      }
      loading.value = false;
      return {
        data,
        pending,
        error,
        refresh,
      };
    } catch (err) {
      loading.value = false;
      console.error(err);
    }
  };

  const getFaxBundles = async (payload) => {
    try {
      loading.value = true;
      const options = {
        method: "POST",
        body: JSON.stringify(payload.body),
      };
      const { data, pending, error, refresh } = await useFetch(
        config.public.BASE_URL + `/public/SelectFaxBundles`,
        options
      );
      if (error.value) {
        console.log(error);
      }
      loading.value = false;
      return {
        data,
        pending,
        error,
        refresh,
      };
    } catch (err) {
      loading.value = false;
      console.error(err);
    }
  };

  const getCloudVolumes = async () => {
    try {
      loading.value = true;
      const options = {
        method: "GET",
      };
      const { data, pending, error, refresh } = await useFetch(
        config.public.BASE_URL + `/public/SelectCloudVolumes`,
        options
      );
      if (error.value) {
        console.log(error);
      }
      loading.value = false;
      return {
        data,
        pending,
        error,
        refresh,
      };
    } catch (err) {
      loading.value = false;
      console.error(err);
    }
  };

  const getAdditionalServices = async (payload) => {
    try {
      loading.value = true;
      const options = {
        method: "POST",
        body: JSON.stringify(payload.body),
      };
      const { data, pending, error, refresh } = await useFetch(
        config.public.BASE_URL + `/public/SelectAdditionalServices`,
        options
      );
      if (error.value) {
        console.log(error);
      }
      loading.value = false;
      return {
        data,
        pending,
        error,
        refresh,
      };
    } catch (err) {
      loading.value = false;
      console.error(err);
    }
  };

  const getNumbers = async (payload) => {
    try {
      loading.value = true;
      const options = {
        method: "POST",
        body: JSON.stringify(payload.body),
      };
      const res = await $fetch(
        config.public.BASE_URL + `/public/SelectNumbers`,
        options
      );

      return res;
    } catch (err) {
      console.error(err);
    } finally {
      loading.value = false;
    }
  };

  const searchNumber = async (payload) => {
    try {
      loading.value = true;
      payload.body.token = useState("token").value || "";
      // payload.body.token = "ebb6f1560246424fbd54d6681db73f1e";

      const options = {
        method: "POST",
        body: JSON.stringify(payload.body),
      };
      const { data, pending, error, refresh } = await useFetch(
        config.public.BASE_URL + `/public/SearchNumber`,
        options
      );
      if (error.value) {
        console.log(error);
      }
      loading.value = false;
      return {
        data,
        pending,
        error,
        refresh,
      };
    } catch (err) {
      loading.value = false;
      console.error(err);
    }
  };

  const setNumber = async () => {
    try {
      loading.value = true;
      const body = {};
      body.BundleId = useState("BundleId").value;
      body.ChannelQuantity =
        useState("BundleName").value == "تلفن ثابت اینترنتی"
          ? "1"
          : useState("ChannelQuantity").value;
      body.didNo = useState("didNo").value;
      if (useState("InitialCredit") || useState("InitialCredit") == 0) {
        body.InitialCredit = useState("InitialCredit").value || "0";
      }
      if (useState("FaxBundleId").value) {
        body.FaxBundleId = useState("FaxBundleId").value;
      }
      if (useState("CloudVolumeId").value) {
        body.CloudVolumeId = useState("CloudVolumeId").value;
      }
      if (useState("IsCrm").value) {
        body.SelectedCrmId = useState("SelectedCrmId").value;
      }
      if (useState("IsWebChat").value) {
        body.SelectedWebChatId = useState("WebchatId").value;
      }
      if (useState("SmsBundleId").value) {
        body.SelectedSmsId = useState("SmsBundleId").value;
        body.IsSms = true;
        if (!useState("BundleId").value)
          body.BundleId = 0;
      }
      body.IsCrm = useState("IsCrm").value;
      body.IsWebChat = useState("IsWebChat").value;

      body.token = useState("token").value || "";
      body.bundleUserCount = useState("bundleUserCount").value || 10;
      // body.token = "ebb6f1560246424fbd54d6681db73f1e";
      const options = {
        method: "POST",
        body: JSON.stringify(body),
      };
      const data = await $fetch(
        config.public.BASE_URL + `/public/SetNumber`,
        options
      );

      return data;

    } 
    catch (err) {
      console.error(err);
    }
    finally {
      loading.value = false;
    }
  };

  const showFactor = async (payload) => {
    try {
      loading.value = true;
      payload.body.token = useState("token").value || "";
      if (useState("selectedNumberType").value) {
        payload.body.type = useState("selectedNumberType").value == "8280"
          ? "CallCenterWithPrefix8"
          : "CallCenterWithPrefix9";
      }
      // payload.body.token = "ebb6f1560246424fbd54d6681db73f1e";
      const options = {
        method: "POST",
        body: JSON.stringify(payload.body),
      };
      const { data, pending, error, refresh } = await useFetch(
        config.public.BASE_URL + `/public/ShowFactor`,
        options
      );
      if (error.value) {
        console.log(error);
      }
      loading.value = false;
      return {
        data,
        pending,
        error,
        refresh,
      };
    } catch (err) {
      loading.value = false;
      console.error(err);
    }
  };

  const getPreFactor = async (payload) => {
    try {
      loading.value = true;
      const options = {
        method: "POST",
        responseType: 'blob',
        body: JSON.stringify(payload.body),
      };
      const data = await $fetch(
        config.public.BASE_URL + `/public/getPreFactor`,
        options
      );
      loading.value = false;
      return data;
    } catch (err) {
      loading.value = false;
      console.error(err);
    }
  };

  const showConditionFactor = async (payload) => {
    try {
      loading.value = true;
      payload.body.token = useState("token").value || "";
      // payload.body.token = "ebb6f1560246424fbd54d6681db73f1e";
      const options = {
        method: "POST",
        body: JSON.stringify(payload.body),
      };
      const { data, pending, error, refresh } = await useFetch(
        config.public.BASE_URL + `/public/ShowConditionFactor`,
        options
      );
      if (error.value) {
        console.log(error);
      }
      loading.value = false;
      return {
        data,
        pending,
        error,
        refresh,
      };
    } catch (err) {
      loading.value = false;
      console.error(err);
    }
  };

  const paymentGatewayInfo = async (payload) => {
    try {
      loading.value = true;
      payload.body.token = useState("token").value || "";
      const options = {
        method: "POST",
        body: JSON.stringify(payload.body),
      };
      const data = await $fetch(
        config.public.BASE_URL + `/public/PaymentGatewayInfo`,
        options
      );
      return data;
    } 
    catch (err) {
      console.error(err);
    }
    finally {
      loading.value = false;
    }
  };

  const returnFromGateway = async (payload) => {
    try {
      loading.value = true;
      const options = {
        method: "POST",
        body: JSON.stringify(payload.body),
      };
      const { data, pending, error, refresh } = await useFetch(
        config.public.BASE_URL + `/public/ReturnFromGateway`,
        options
      );
      if (error.value) {
        console.log(error);
        if (error.value.statusCode == 500) {
          location.reload();
        }
      }
      loading.value = false;
      return {
        data,
        pending,
        error,
        refresh,
      };
    } catch (err) {
      loading.value = false;
      console.error(err);
    }
  };

  const returnFromGatewayShowFactor = async (payload) => {
    try {
      loading.value = true;
      const options = {
        method: "POST",
        body: JSON.stringify(payload.body),
      };
      const { data, pending, error, refresh } = await useFetch(
        config.public.BASE_URL + `/public/ReturnFromGatewayShowFactor`,
        options
      );
      if (error.value) {
        console.log(error);
        if (error.value.statusCode == 500) {
          location.reload();
        }
      }
      loading.value = false;
      return {
        data,
        pending,
        error,
        refresh,
      };
    } catch (err) {
      loading.value = false;
      console.error(err);
    }
  };

  const applyDiscountCode = async (payload) => {
    try {
      loading.value = true;

      payload.body.token = useState("token").value || "";
      // payload.body.token = "ebb6f1560246424fbd54d6681db73f1e";
      const options = {
        method: "POST",
        body: JSON.stringify(payload.body),
      };
      const { data, pending, error, refresh } = await useFetch(
        config.public.BASE_URL + `/public/ApplyDiscountCode`,
        options
      );
      if (error.value) {
        console.log(error);
      }
      loading.value = false;
      return {
        data,
        pending,
        error,
        refresh,
      };
    } catch (err) {
      loading.value = false;
      console.error(err);
    }
  };

  const searchNumberWithPrice = async (payload) => {
    try {
      loading.value = true;

      const options = {
        method: "POST",
        body: JSON.stringify(payload.body),
      };
      const res = await $fetch(
        config.public.BASE_URL + `/public/SelectNumbersWithPriceAndNumber`,
        options
      );

      return res;
    } catch (err) {
      console.error(err);
    } finally {
      loading.value = false;
    }
  };

  const searchOpalNumberWithPrice = async (payload) => {
    try {
      loading.value = true;

      const options = {
        method: "POST",
        body: JSON.stringify(payload.body),
      };
      const { data, pending, error, refresh } = await useFetch(
        config.public.BASE_URL + `/public/SelectNumbersWithPriceAndNumberHighPrice`,
        options
      );
      if (error.value) {
        console.log(error);
      }
      loading.value = false;
      return {
        data,
        pending,
        error,
        refresh,
      };
    } catch (err) {
      loading.value = false;
      console.error(err);
    }
  };

  const searchNumberWithLowPrice = async (payload) => {
    try {
      loading.value = true;

      const options = {
        method: "POST",
        body: JSON.stringify(payload.body),
      };
      const { data, pending, error, refresh } = await useFetch(
        config.public.BASE_URL + `/public/SelectNumbersWithPriceAndNumberLowPrice`,
        options
      );
      if (error.value) {
        console.log(error);
      }
      loading.value = false;
      return {
        data,
        pending,
        error,
        refresh,
      };
    } catch (err) {
      loading.value = false;
      console.error(err);
    }
  };

  const pushItemsToDataLayer = async (data) => {
    dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
    dataLayer.push({
      event: "purchase",
      ecommerce: {
        transaction_id: data?.refnum,
        value: data.total_detail?.total_amount,
        tax: data.total_detail?.vat,
        currency: "USD",
        coupon: "OnlineSell",
        package: data?.details[0]?.title,
      },
    });
  };

  const preFactorReserveDid = async (payload) => {
    try {
      loading.value = true;

      const options = {
        method: "POST",
        body: JSON.stringify(payload.body),
      };
      const { data, pending, error, refresh } = await useFetch(
        config.public.BASE_URL + `/public/preFactorReserveDid`,
        options
      );
      if (error.value) {
        console.log(error);
      }
      loading.value = false;
      return {
        data,
        pending,
        error,
        refresh,
      };
    } catch (err) {
      loading.value = false;
      console.error(err);
    }
  };
  return {
    register,
    verifyOTP,
    resendOTP,
    getBundles,
    getFaxBundles,
    getCloudVolumes,
    getAdditionalServices,
    getNumbers,
    searchNumber,
    setNumber,
    showFactor,
    showConditionFactor,
    paymentGatewayInfo,
    returnFromGateway,
    returnFromGatewayShowFactor,
    applyDiscountCode,
    searchNumberWithPrice,
    searchOpalNumberWithPrice,
    searchNumberWithLowPrice,
    pushItemsToDataLayer,
    preFactorReserveDid,
    loading,
    getPreFactor,
  };
};

export default useOnlineShopping;
